import { render, staticRenderFns } from "./prompt-wrapper.vue?vue&type=template&id=f0726cb8&scoped=true&"
import script from "./prompt-wrapper.vue?vue&type=script&lang=js&"
export * from "./prompt-wrapper.vue?vue&type=script&lang=js&"
import style0 from "./prompt-wrapper.vue?vue&type=style&index=0&id=f0726cb8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0726cb8",
  null
  
)

export default component.exports